export enum WREX_EMOJI {
    /**
     * @value Emojis
     * @description The label of the button to insert an emoji in the rich editor toolbar.
     */
    EMOJI_BUTTON = 'WREX_EMOJI.EMOJI_BUTTON',
    /**
     * @value Insert emoji
     */
    EMOJI_TOOLTIP = 'WREX_EMOJI.EMOJI_BUTTON_TOOLTIP',
}
